
import { SuggestedFuelStop } from '@clients/myTrips';
import { objectToQueryParam } from '@util/parseQueryUtils';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import AppListItem from '@components/new-styleguide/AppListItem.vue';

@Component({
  name: 'SuggestedFuelStopField',
  components: {
    AppListItem
  }
})
export default class SuggestedFuelStopField extends Vue {
  @Prop({ required: true })
  private fuelStop: SuggestedFuelStop;

  @Prop({ required: true })
  private vehicleId: number;

  get value() {
    return { title: 'Tanken', subtitle: 'Waren Sie tanken?', tagIcon: this.tagIcon, hasButton: true };
  }

  get tagIcon() {
    return { value: 'tag_fuel_tank', color: '#0b6dc4', fill: 'white' };
  }

  get createFuelStop() {
    return {
      name: 'fuelStopAdd',
      query: { vehicle: this.vehicleId, suggested: objectToQueryParam(this.fuelStop) },
    }
  }
}
